/**
 * Interface for case toggle option items
 */
interface CaseToggleOption {
	readonly label: string,
	readonly value: string
}

/**
 * Configuration options for letter case toggle in system settings.
 * 
 * @description Defines the available options for controlling whether 
 * generated code should be uppercase or lowercase.
 * 
 * - 'true': Generates uppercase code (preserves original case)
 * - 'false': Generates lowercase code (converts to lowercase)
 */
export const caseToggleOptions: readonly CaseToggleOption[] = [
	{
		value: 'true',
		label: 'Uppercase',
	},
	{
		value: 'false',
		label: 'Lowercase',
	},
] as const
